import React, { useEffect, useState } from "react";
import Navbar from "../Navbar";
import { Box, Button, TextField, Grid, Typography } from "@mui/material";
import axios from "axios";
import swal from "sweetalert";
import Divider from "@mui/material/Divider";
import { Link, useNavigate, useParams } from "react-router-dom";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import {
  createTheme,
  PaletteColorOptions,
  ThemeProvider,
} from "@mui/material/styles";
import { Stack } from "@mui/material";

function AddItemDetails() {
  const navigate = useNavigate();

  //useState declaration
  const [productInput, setProduct] = useState({
    categoryname: "",
    subcategoryname: "",
    itemname: "",
    itemdesc: "",
    error_list: [],
  });

  //input handling function
  const handleInput = (e) => {
    e.persist();
    setProduct({ ...productInput, [e.target.name]: e.target.value });
  };

  //colour palette
  const { palette } = createTheme();
  const { augmentColor } = palette;
  const createColor = (mainColor) =>
    augmentColor({ color: { main: mainColor } });
  const theme = createTheme({
    palette: {
      anger: createColor("#F40B27"),
      apple: createColor("#A38A00"),
      steelBlue: createColor("#5C76B7"),
      violet: createColor("#BC00A3"),
    },
    button: {
      // Here is where you can customise the button
      fontSize: 16,
      fontWeight: 1700,
    },
  });

  //submit function
  const submitProduct = (e) => {
    e.preventDefault();
    let userId = localStorage.getItem("auth_id");
    console.log(userId);
    const data = {
      categoryname: productInput.categoryname,
      subcategoryname: productInput.subcategoryname,
      itemname: productInput.itemname,
      itemdesc: productInput.itemdesc,
      user_id:userId,
    };

    //api calling
    axios.post(`api/add_categorydetails`, data).then((res) => {
      if (res.data.status === 200) {
        swal("Success", res.data.message, "success");
        document.getElementById("CATEGORY_FORM").reset();
        navigate('/certificates/categorydetails');
      } else if (res.data.status === 400) {
        setProduct({ ...productInput, error_list: res.data.errors });
      }
    });
  };

  //dropdown
  const [sublist, setsublist] = useState([]);
  useEffect(() => {
    axios.get(`api/show-product`).then((res) => {
      if (res.status === 200) {
        setsublist(res.data.product);
      }
    });
  }, []);
  const values = sublist.map((itemname) => {
    return (
      <option color="blue" value={sublist.categoryname}>
        {itemname.name}
      </option>
    );
  });

  const [subcatlist, setsubcatlist] = useState([]);
  useEffect(() => {
    axios.get(`api/show_subcategory`).then((res) => {
      if (res.status === 200) {
        setsubcatlist(res.data.subcategory);
      }
    });
  }, []);
  const subvalues = subcatlist.map((itemvalue) => {
    return (
      <option color="blue" value={subcatlist.subcategoryname}>
        {itemvalue.subname}
      </option>
    );
  });

  return (
    <div>
      <Navbar />
      {/* <div className="card px-8 m-5">
        <div className="card-header">
          <Grid container spacing={70}>
            <Grid item xs={8}>
              <h4>Add Category</h4>
            </Grid>
            <Grid item xs={4}>
              <ThemeProvider theme={theme}>
                <Button
                  component={Link}
                  to="/certificates/categorydetails"
                  variant="contained"
                  color="apple"
                >
                  Back
                </Button>
              </ThemeProvider>
            </Grid>
          </Grid>
        </div>
        <form onSubmit={submitProduct} id="CATEGORY_FORM">
          <Box paddingTop={5} borderRadius={1} paddingLeft={5} paddingRight={5}>
            <Grid container spacing={5}>
              <Grid item xs={6}>
                <select
                  name="categoryname"
                  className="form-control"
                  onChange={handleInput}
                  value={productInput.categoryname}
                >
                  <option selected>--Category--</option>
                  {values}
                </select>

                <span style={{ color: "red" }}>
                  {productInput.error_list.categoryname}
                </span>
              </Grid>
              <Grid item xs={6}>
               
                <select
                  name="subcategoryname"
                  className="form-control"
                  onChange={handleInput}
                  value={productInput.subcategoryname}
                >
                  <option selected>--Sub Category--</option>
                  {subcatlist.map(post=><option key={post.subname}>{post.subname}</option>)}
                </select>
                <span style={{ color: "red" }}>
                  {productInput.error_list.subcategoryname}
                </span>
                
              </Grid>
            </Grid>
          </Box>
          <Box paddingTop={1} borderRadius={1} paddingLeft={5} paddingRight={5}>
            <Grid container spacing={5}>
              <Grid item xs={6}>
                <TextField
                  InputProps={{ sx: { height: 50 } }}
                  fullWidth
                  name="itemname"
                  id="outlined-basic"
                  onChange={handleInput}
                  value={productInput.itemname}
                  margin="normal"
                  label="Item Name"
                  variant="outlined"
                />
                {productInput.error_list.itemname}
              </Grid>
              <Grid item xs={6}>
                <TextField
                 
            multiline
            rows={2}
            maxRows={4}
                  
                  fullWidth
                  name="itemdesc"
                  id="outlined-basic"
                  onChange={handleInput}
                  value={productInput.itemdesc}
                  margin="normal"
                  label="Item Description"
                  variant="outlined"
                />
                <span style={{ color: "red" }}>
                  {productInput.error_list.itemdesc}
                </span>
              </Grid>
            </Grid>
          </Box>

          <ThemeProvider theme={theme}>
            <Box
              marginTop={1}
              display="flex"
              padding={3}
              borderRadius={5}
              alignItems="center"
              justifyContent={"center"}
            >
              <Button
                style={{
                  maxWidth: "200px",
                  maxHeight: "100px",
                  minWidth: "50px",
                  minHeight: "30px",
                }}
                color="apple"
                type="submit"
                variant="contained"
              >
                Add
              </Button>
            </Box>
          </ThemeProvider>
        </form>
      </div> */}
      <form onSubmit={submitProduct} id="CATEGORY_FORM">
      <div className="row" style={{ marginTop: 20, width: "97%" }}>
                        // <div className="col-sm-1"></div>
                        <div className="col-sm-12" style={{ marginLeft: 40 }}>
                            <div className="card">
                                <div className="card-header">
                                <div class="d-flex justify-content-between">
                                  <h4><b>Add Category Details</b></h4>
                                  <ThemeProvider theme={theme}>
           <Button component={Link} to="/certificates/categorydetails" variant='contained' color='apple'>Back</Button>
           </ThemeProvider></div>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-sm-4" style={{ marginBottom: "15px" }}>
                                            <div className="form-group ">
                                                <label className="required" style={{ marginBottom: "7px" }}>Category</label>
                                                <select name="categoryname" id="categoryname" className="form-control"  onChange={handleInput} value={productInput.categoryname}>
                                                    <option value="">-- Category --</option>
                                                    {sublist.map(post=><option key={post.name}>{post.name}</option>)}
                                                </select>
                                                <span style={{ color: "red" }}>
                                                  {productInput.error_list.categoryname}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="col-sm-4" style={{ marginBottom: "15px" }}>
                                        <div className="form-group ">
                                                <label className="required" style={{ marginBottom: "7px" }}>Sub Category</label>
                                                <select name="subcategoryname" id="subcategoryname" className="form-control"  onChange={handleInput} value={productInput.subcategoryname} >
                                                    <option value="">-- Sub Category --</option>
                                                    {subcatlist.map(post=><option key={post.subname}>{post.subname}</option>)}
                                                </select>
                                                <span style={{ color: "red" }}>
                                                  {productInput.error_list.subcategoryname}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="col-sm-4" style={{ marginBottom: "15px" }}>
                                        <div className="form-group ">
                                                <label className="required" style={{ marginBottom: "7px" }}>Item Name</label>
                                                <input type="text" name="itemname" id="itemname" className="form-control" placeholder="Enter Item Name" onChange={handleInput} value={productInput.itemname}/>
                                                <span style={{ color: "red" }}>
                                                  {productInput.error_list.itemname}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="col-sm-12" style={{ marginBottom: "15px" }}>
                                          <div className="form-group ">
                                              <label className="required" style={{ marginBottom: "7px" }}>Item Description</label>
                                              <textarea type="text" name="itemdesc" id="itemdesc" className="form-control" placeholder="Enter Item Description" onChange={handleInput} value={productInput.itemdesc}/>
                                              <span style={{ color: "red" }}>
                                                  {productInput.error_list.itemdesc}
                                                </span>
                                          </div>
                                        </div>
                                        
                                    </div >

                                    {/* --------------------Item details Add more Display data Start ----------------*/}
                                    
                                    {/* --------------------Item details Add more Display data End ----------------*/}
                                </div>
                                <div className="card-footer text-center"> <button type="submit" id="submit" style={{ backgroundColor: "#A38A00", color: "white" }} className="btn btn-default text-center" disabled={false}>Add</button></div>
                            </div>
                            
                        </div>
                        
                    </div>
                    </form>
      
    </div>
  );
}

export default AddItemDetails;
